import React, {useEffect, useState} from 'react';
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import {useDispatch, useSelector} from "react-redux";
import {
    getAnaesthetistsFilter, getConfig,
    getConsultantsFilter, getSurgeonsFilter,
    handleSessionClick, setAnaesthetistsFilter, setConsultantsFilter, setSurgeonsFilter,
} from '../../../store/reducers/booked_admissions';
import Grid from '@mui/material/Grid';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import {hasBAPermission, Permissions, user} from '../../../store/reducers/user';
import {
   AdmissionAnaesthetistDropdown,
    AdmissionConsultantDropdown,
    AdmissionSurgeonDropdown,
} from '../../../controls/agyle/dictionaries';
import API from '../../../app/api';
import moment from 'moment/moment';
import AgyleDialog from '../../../components/modal/agyleDialog';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import config from '../../../app/config';

export const useStyles = makeStyles((theme) => ({
    menu: {
        width: "25%",
        paddingRight: 10,
        borderRight: "1px solid #ffffff1f",
        height: "calc(100vh - 100px)"
    },
    content: {
        paddingLeft: 10,
        width: "75%",
        height:  "calc(100vh - 100px)",
        overflow: "auto"
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        color: "grey"
    },
    menuItemSelected: {
        borderRadius: 10,
        borderRight: "3px solid #2180F7",
        display: "flex",
        alignItems: "center",
        color: theme.palette.bookAdmissions.settingMenuItemSelectedText,
        backgroundColor: theme.palette.bookAdmissions.settingMenuItemSelectedBackground
    },
    saveButton: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: "20px",
        position: "absolute",
        top: 12,
        right: 35
    },
    accordion: {
        backgroundColor: theme.palette.bookAdmissions.settingAccordionBackground
    },
    typography: {
        width: "100%"
    },
    headerContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    sessionItem: {
        background:  theme.palette.bookAdmissions.dcLabelBackground,
        padding: 10,
        marginBottom: 10,
        borderRadius: 6,

    },
    sessionLabel: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "10px",

    },
    sessionHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
        marginBottom: 10
    },
    sessionDetailsLabel: {
        color: "#ACAFB3",
        marginRight: 5
    },
    sessionDetailsItem: {
        //  width: "25%",
        fontSize: 13,
        marginBottom: 5
    },
    sessionTime: {
        background: "#ACAFB3",
        color: "black",
        borderRadius: 10,
        fontSize: 10,
        padding: "1px 7px 1px 7px"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb"
    },
    noSessionText: {
        textAlign: "center",
        fontWeight: 200
    }

}));

const MySessionModal = (props) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const userObject = useSelector(user);

    // const [consultantsFilter, setConsultantsFilter] = useState([]);
    // const [surgeonsFilter, setSurgeonsFilter] = useState([]);
    // const [anastFilter, setAnastFilter] = useState([]);

    const consultantsFilter = useSelector(getConsultantsFilter);
    const surgeonsFilter = useSelector(getSurgeonsFilter);
    const anaesthetistsFilter = useSelector(getAnaesthetistsFilter);

    const [sessions, setSessions] = useState([]);

    const filterSessions = (sessions) => {
        return sessions.filter((session) => {
              let isValid = false;

              if (consultantsFilter && consultantsFilter.length > 0) {
                  isValid = consultantsFilter.some((consultant) => consultant.id === session.consultant?.id)
              }

              if (!isValid && surgeonsFilter && surgeonsFilter.length > 0) {
                  isValid = surgeonsFilter.some((surgeon) => surgeon.id === session.surgeon?.id)
              }

              if (!isValid && anaesthetistsFilter && anaesthetistsFilter.length > 0) {
                  isValid = anaesthetistsFilter.some((anast) => anast.id === session.anaesthetists?.id)
              }

              return isValid
        })

    }

    const setDefaultUser = () => {
        let urlConsultant = `/admission/person/consultant?userName=${userObject.userName}`;
        let urlSurgeon = `/admission/person/surgeon?userName=${userObject.userName}`;
        let urlAnaesthetist = `/admission/person/anaesthetist?userName=${userObject.userName}`;

        API.getDictByURL(urlConsultant).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                dispatch(setConsultantsFilter(dictData))
            }
        }).catch(function (error) {
            console.error("Consultant Filter", error);
        });

        API.getDictByURL(urlSurgeon).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                dispatch(setSurgeonsFilter(dictData))
            }
        }).catch(function (error) {
            console.error("Surgeons Filter", error);
        });


        API.getDictByURL(urlAnaesthetist).then(dictData => {
            if (dictData && !_.isEmpty(dictData)) {
                dispatch(setAnaesthetistsFilter(dictData))
            }
        }).catch(function (error) {
            console.error("Anaesthetists Filter", error);
        });
    }

    useEffect(() => {
        setDefaultUser();
    },[userObject])

    useEffect(() => {
        API.getSesions(moment().format("YYYY-MM-DD"),
                moment().add(4,"weeks").format("YYYY-MM-DD"), "TCI").then(sessions => {
                setSessions(sessions);

            }).catch(function (error) {
                // TODO: error handler !!!
                console.error(error);
            });

    },[])

    const openSession = (session) => {
        dispatch(handleSessionClick(session));
        props.closeUserModal()
    }
    const configBA = useSelector(getConfig);
    const timezone = config?.defaultTimezone || 'Europe/London';

    const getStartTimeSession = (session) => {
        let time = moment.tz(session.day, timezone).format("HH:mm");
        if(session.importId && time === "00:00") time = configBA.timeOfDayRanges[session.timeOfDay.code].startHour
        else time = moment(session.day).format("HH:mm")
        return moment(time,"HH:mm");
    }

    const getTimeEndForSession = (session) => {
        let time = 0;
        session.bookedSessions.forEach((item)=> {
            if(!item.holdingPen) time += item.timeLen
        })
        return getStartTimeSession(session).add(time > session.maxTime? time : session.maxTime, "minutes");
    }

    const renderSessionList = () => {
        let sessionToRender = filterSessions(sessions);
        if(sessionToRender.length === 0) return <div className={classes.noSessionText}> No sessions for the selected criteria </div>;

        return sessionToRender?.map((session)=>{
            return <div className={classes.sessionItem} >
                <div className={classes.sessionHeader}>
                    <div className={classes.sessionLabel}>
                        <div> {moment(session.day).format("Do of MMMM ")} </div>
                        <div className={classes.sessionTime}> {session.timeOfDay.code.toUpperCase()} </div>
                    </div>

                    <div> <AgyleButton onClick={()=>{openSession(session)}}
                                       variant={"outlined"} size={"small"}> {t('Go to Session ')} </AgyleButton> </div>
                </div>
                <Grid container columns={10}>
                    <Grid item xs={4}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Theatre </span> {session.theatre.description?? "-"}
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Duration </span> {getStartTimeSession(session).format("HH:mm")} - {getTimeEndForSession(session).format("HH:mm")}
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Specialty </span> {session.specialty?.__description ?? "-"}
                        </div>
                    </Grid>

                    <Grid item xs={4}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Surgeon </span> {session.surgeon?.name ?? "-"}
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Consultant</span> {session.consultant?.name ?? "-"}
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        <div className={classes.sessionDetailsItem}>
                            <span className={classes.sessionDetailsLabel}> Anaesthetists </span> {session.anaesthetists?.name ?? "-"}
                        </div>
                    </Grid>
                </Grid>

            </div>
        })
    }

    return(<>
            <div style={{display: "flex"}}>
                        <div className={classes.menu}>
                            <AdmissionConsultantDropdown
                                name="AdmissionConsultant"
                                color="primary"
                                size={"small"}
                                label={t('Overseeing Consultant')}
                                multiple
                                disabed
                                inputWithTag
                                value={consultantsFilter}
                                onChange={(el)=>{dispatch(setConsultantsFilter(el))}}
                                placeholder={t("Type to see more records")}
                            />

                            <div style={{height: 20}}/>
                            <AdmissionSurgeonDropdown
                                name="AdmissionSurgeon"
                                color="primary"
                                size={"small"}
                                label={t('Surgeon')}
                                multiple
                                disabed
                                inputWithTag
                                value={surgeonsFilter}
                                onChange={(el)=>{dispatch(setSurgeonsFilter(el))}}
                                placeholder={t("Type to see more records")}
                            />
                            <div style={{height: 20}}/>
                            <AdmissionAnaesthetistDropdown
                                name="AdmissionAnaesthetist"
                                label={"Anaesthetist"}
                                multiple
                                inputWithTag
                                color="primary"
                                value={anaesthetistsFilter}
                                onChange={(el)=>{dispatch(setAnaesthetistsFilter(el))}}
                                placeholder={t("Type to see more records")}
                            />

                        </div>
                        <div className={clsx(classes.content, "scroll-normal-white")}>
                            {renderSessionList()}
                        </div>
                    </div>

    </>
    );
}

export default MySessionModal